module.exports = __webpack_public_path__ + "img/undraw_happy_announcement_ac_67.90e5b696.png";